import type { CardState } from './derive';

// Replaces the old Connection/HeartbeatIndicator row: freshness lives in the
// header dot and only gets loud (STALE/OFFLINE tag) when something is wrong.
export function PulseDot({ state }: { state: CardState }) {
  if (state === 'live') {
    return (
      <span
        data-testid="pulse-dot-live"
        className="mt-1 inline-block h-2.5 w-2.5 rounded-full bg-ems-green shadow-ems-glow animate-ems-pulse"
      />
    );
  }
  const tag = state === 'stale' ? 'STALE' : state === 'offline' ? 'OFFLINE' : null;
  return (
    <span className="mt-1 flex items-center gap-1.5">
      {tag && (
        <span className="text-[9px] font-semibold tracking-wider text-ems-text-muted">{tag}</span>
      )}
      <span className="inline-block h-2.5 w-2.5 rounded-full bg-ems-text-muted/50" />
    </span>
  );
}
